// extracted by mini-css-extract-plugin
export default {"Box_0":"VisibleAndOverflowContainer-module__Box_0--KyT2b","space":"VisibleAndOverflowContainer-module__space--fVHr3"};